<template>
    <div name="steps" class="steps">
        <div class="stepper" v-if="isStepper && !isRare"> 
            <div v-if="step == 1" class="step active">1
                <span class="step-text active">환자 정보</span>
            </div>
            <div v-else class="step">1
                <span class="step-text">환자 정보</span>
            </div>
            <div class="line"></div>
            <div v-if="step == 2" class="step active">2
                <span class="step-text active">청구 위임</span>
            </div>
            <div v-else class="step">2 
                <span class="step-text">청구 위임</span>
            </div>
            <div class="line"></div>
            <div v-if="step == 3" class="step active">3
                <span class="step-text">카드 등록</span>
            </div>
            <div v-else class="step">3
                <span class="step-text">카드 등록</span>
            </div>
            <div class="line"></div>
            <div v-if="step == 4" class="step active">4
                <span class="step-text">완료</span>
            </div>
            <div v-else class="step">4
                <span class="step-text">완료</span>
            </div>
            
        </div>
        <div class="stepper" v-if="isStepper && isRare"> 
            <div v-if="step == 1" class="step active">1
                <span class="step-text active">환자 정보</span>
            </div>
            <div v-else class="step">1
                <span class="step-text">환자 정보</span>
            </div>
            <div class="line"></div>
            <div v-if="step == 3" class="step active">2
                <span class="step-text">카드 등록</span>
            </div>
            <div v-else class="step">2
                <span class="step-text">카드 등록</span>
            </div>
            <div class="line"></div>
            <div v-if="step == 4" class="step active">3
                <span class="step-text">완료</span>
            </div>
            <div v-else class="step">3
                <span class="step-text">완료</span>
            </div>
            
        </div>
        <div class="column-box" style="margin-top: 30px; " v-if="step===1">
            <span class="title">환자 정보를 입력해 주세요</span>
            <span class="description">서비스 이용을 위한 한 번의 환자 등록!<br/> <span class="description-strong">진료 받으실 분의 정보</span>를 등록해 주세요</span>
        </div>
        <div class="column-box" style="margin-top: 30px;" v-if="step===2">
            <span class="title">{{ title }}</span>
            <span class="description">솔닥에 위임하고<br/><span class="description-strong">본인부담금만 결제하세요</span></span>
        </div>
        
        <div class="column-box" style="margin-top: 30px;" v-if="step===3">
            <span class="title">결제 카드를 등록해 주세요</span>
            <span class="description"><span class="description-strong">비대면진료/소모성재료 결제</span>를 위한 한 번의 카드 등록!</span>
            <!-- <span class="description" style="margin-top: 8px;"><span class="description-strong" style="color:#008DEF">하나카드</span>는 현재 지원하지 않습니다.</span> -->
            <span class="description"><span class="description-strong">5만원 이상 무이자 할부 </span>가능합니다. <span class="description-strong">상담원에게 문의</span>해주세요. </span>
        </div>
        <div class="column-box" style="margin-top: 30px;" v-if="step===4">
            <span class="title">환자등록이 완료되었습니다!</span>
            <span class="description">이제 마이페이지에서 진료 예약, 물품 구매, 서류 확인, 개인정보 관리가 가능해요.</span>
        </div>
        
    </div>
</template>

<script>
import {mapState} from 'vuex';
// step 표현 
export default {
    name: 'steps',
    props: ['step', 'title', 'isStepper', 'isRare'],
    computed: mapState(['status']),
    methods: {
        moveStep: function(step)
        {
            // this.$emit('move', step)
            // last step
            
            if(step === 1)
            {
                this.$router.push({path: '/medical'})
            }   
            else if(step === 2)
            {
                this.$router.push({path: '/contract'})
            }
            else if(step === 3)
            {
                this.$router.push({path: '/card'})
            }
            else if(step === 4)
            {
                this.$router.push({path: '/booking'})
            }
        }
    }
}
</script>

<style scoped>
    .steps {
        width: calc(100%);
        background: var(--Gray-20, #F3F5F8);
        padding: 0px 16px 16px 16px;
        box-sizing: border-box;
    }
    .column-box {
        display: flex;
        flex-direction: column;
    }

    .row-box {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-content: center;
        position: relative;
    }

    .description {
        color: var(--Gray-60, #6B7684);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px; /* 122.222% */
        margin-top: 16px;
    }
    .description-strong {
        color: var(--Gray-100, #1E1E1E);
        font-weight: 600;
    }
    .title {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 24px;
        font-style: normal;
        font-weight: 600;
        line-height: 26px; /* 108.333% */
    }
    .logo {
        width: 94px;
        flex-shrink: 0;
    }
    .stepper {
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        padding-bottom: 30px;
    }

    .step {
        width: 28px;
        height: 28px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 18px;
        font-weight: bold;
        position: relative;
    }

    .step.active {
        background-color: #184FA1; /* 파란색 배경 */
        color: var(--Gray-00, #FFF);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px; /* 122.222% */
    }

    .step:not(.active) {
        background-color: #E8EAEE; /* 회색 배경 */
        color: var(--Gray-60, #6B7684);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px; /* 122.222% */
    }

    .line {
        max-width: 17%;
        width: 17%;
        height: 5px;
        background: var(--gray-30-stroke, #E8EAEE);
    }
    .step-text {
        color: var(--Gray-100, #1E1E1E);
        text-align: center;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px; /* 122.222% */
        margin-right: 16px;
        margin-left: 16px;
        width: 67px;
        position: absolute;
        top: 41px;
    
    }
    .step-text:not(.active) {

        color: var(--Gray-60, #6B7684);
        text-align: center;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px; /* 122.222% */
        margin-right: 16px;
        margin-left: 16px;
        width: 67px;
    }
</style>


// WEBPACK FOOTER //
// src/components/molecules/Steps.vue